import { render, staticRenderFns } from "./VenuesTab.vue?vue&type=template&id=b6f7a12a&scoped=true&"
import script from "./VenuesTab.vue?vue&type=script&lang=js&"
export * from "./VenuesTab.vue?vue&type=script&lang=js&"
import style0 from "./VenuesTab.vue?vue&type=style&index=0&id=b6f7a12a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f7a12a",
  null
  
)

export default component.exports